import React from 'react';
import TruncateText from '../../../components/TruncateText';
import Box from '../../../spa/core-components/Box';
import { Avatar } from '../../../spa/core-components/Avatar';
import Paragraph from '../../Paragraph';
import Stars from '../../Stars';
import VerticalSpacing from '../../VerticalSpacing';
import AvatarWithRole from '../../AvatarWithRole';
import { ClientReview } from './ReviewCard';

export interface Props {
    clientReview: ClientReview;
    clientName: string;
    avatarUrl: string;
}

const ReviewTabContent = ({ clientReview, clientName, avatarUrl }: Props) => (
    <Box paddingTop="space7" display="flex" flexDirection="column" flexGrow={1} height="100%">
        <Stars rating={clientReview.rating} scale={1} />
        <VerticalSpacing verticalSpacing="space7" />
        <Paragraph variations={['no-margin']}>
            <TruncateText text={`"${clientReview.review}"`} maxHeight={120} />
        </Paragraph>
        <Box paddingTop="space6" display="flex" flexGrow={1} alignItems="flex-end">
            <AvatarWithRole
                avatar={<Avatar avatarUrl={avatarUrl} size={'small'} userName={clientName} />}
                name={clientName}
                role={__('Client')}
            />
        </Box>
    </Box>
);

export default ReviewTabContent;
